document.querySelectorAll('.avautuvasisalto2__panel').forEach(panel => {
    panel.addEventListener('click', () => {
        const isOpen = panel.classList.contains('is-open');
        if (!isOpen) {
            // Close all panels
            document.querySelectorAll('.avautuvasisalto2__panel').forEach(p => {
                p.classList.remove('is-open');
                p.classList.add('is-closed');
            });

            // Open clicked panel
            panel.classList.add('is-open');
            panel.classList.remove('is-closed');
        }
    });
});
